import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import image6 from "../../../images/avatar/2.jpg";
import { FaMapPin } from "react-icons/fa";
import SyncLoader from "react-spinners/SyncLoader";
import "./List.css";
import axios from "../../../api/axios";

const List = ({ listAll }) => {
  const decor = {
    textDecoration: "none",
  };
  const LIST_URL = "/api/index/visitor/property";

  const [products, setProducts] = useState([]);
  const [salesList, setSalesList] = useState([]);
  const [rentList, setRentList] = useState([]);
  const [listToShow, setListToShow] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(LIST_URL)
      .then((res) => {
        const { data } = res.data;
        setProducts(listAll ? data : data.slice(0, 6));

        const rentListings = data.filter((rentItem) => {
          return rentItem.property_category === "rent";
        });
        const saleListings = data.filter((saleItem) => {
          return saleItem.property_category === "sale";
        });
        setRentList(rentListings);
        setSalesList(listAll ? saleListings : saleListings.slice(0, 6));
        setListToShow(listAll ? data : data.slice(0, 6));
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [LIST_URL, listAll]);

  return (
    <div>
      <div className="section-headers">
        <div className="section-title">
          <h2>Latest Properties</h2>
        </div>
        <div className="section-right-bar">
          <div onClick={() => setListToShow(products)}>
            <p>All Categories</p>
          </div>
          <div onClick={() => setListToShow(rentList)}>
            <p>For Rent</p>
          </div>
          <div onClick={() => setListToShow(salesList)}>
            <p>For Sale</p>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div className="loading">
          <SyncLoader color={"#098FD2"} loading={isLoading} size={10} />
        </div>
      ) : (
        <div className="list-container">
          {listToShow.map((product) => {
            const {
              slug,
              property_name,
              property_image,
              property_price,
              state,
              data_added,
              property_category,
              user_data: { username },
            } = product;

            // console.log(property_category);

            return (
              <div>
                <div key={slug}>
                  <NavLink style={decor} to={`/property/${slug}`}>
                    <div className="list-wrapper">
                      <div className="list-img-container">
                        <img
                          className="list-img"
                          src={property_image}
                          alt="image3"
                        />
                      </div>
                      <div className="list-bg">
                        <h5>{property_name}</h5>
                        <h4>₦ {property_price}</h4>
                        <p>
                          <span className="map-pin">
                            <FaMapPin />
                          </span>{" "}
                          {state}
                        </p>
                        <p className="uppercase">
                          <span className="map-pin">
                            <span className="for">For</span>
                          </span>
                          {property_category}
                        </p>
                        <div className="list-icons"></div>
                        {/* <hr className="list-hr" /> */}
                        <div className="list-user">
                          <div className="user">
                            <img src={image6} alt="user2" />
                            <p>{username}</p>
                          </div>
                          <div className="rating">{data_added}</div>
                        </div>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default List;
